'use strict';

angular.module('pulianiBookStoreApp')
  .controller('CategoryCtrl', function($scope, $state, $anchorScroll, $location, product, productCategory, $stateParams, Global, Auth, MyCart, CategoryService, toaster, $uibModal, $rootScope) {
    $rootScope.title = $state.params.name;
    $scope.subCategory = {};
    productCategory.getCategoryProductCategoryTree($state.params.id)

    .then(function(subCategory) {

      formSubCategory(subCategory.data);
      })
      .catch(function(error) {

        console.log("error-->", error);
      });
    $scope.color1 = {
      background: 'blue'
    }
    var categories = [];
    // $scope.options = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','ab'];
    $scope.mainCategory = $state.params.name;
 

    
    $('#'+$scope.mainCategory.replace(' ','_')).css('backgroundColor','#DDAF37');
    //console.log($scope.mainCategory);
    $anchorScroll.yOffset = 190;
    $scope.shoWSelectedList = function(option) {
      $scope.selectedList = {
        key: option,
        list: []
      };
      $scope.selectedCategory = true;
      $scope.seeAllOption = true;
      $scope.fullCategoryList = false;
      for (var category in $scope.subCateogories) {
        if (option.toLowerCase() === category.toLowerCase()) {
          $scope.selectedList = {
            key: category,
            list: $scope.subCateogories[category]
          };
          console.log($scope.selectedList);
          break;
        }
      }
    }
    $scope.showAllList = function() {
      $scope.fullCategoryList = true;
      $scope.selectedCategory = false;
      $scope.seeAllOption = false;
    }

    var formSubCategory = function(subCategory) {
      var tmp = {};
      subCategory = subCategory[0].child;
      subCategory = sortCategoryName(subCategory);
      // for(var r=0;r<5;r++)
      // 	subCategory.push(name:'pqrs',id:10);

      for (var i = 0; i < subCategory.length; i++) {
        var letter = subCategory[i].name.charAt(0);
        if (tmp[letter] == undefined) {
          tmp[letter] = []
        }
        tmp[letter].push(subCategory[i]);
      }
      $scope.fullCategoryList = true;
      $scope.subCateogories = sortObject(tmp);
      for (var key in $scope.subCateogories) {
        categories.push(key);
      }
      //$scope.options = categories;	
      $scope.options = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    }

    function sortCategoryName(category){
      category =  category.sort(function(a,b){
           return a.id - b.id;
      })
      return category;
    }

    $scope.redirectTo = function(category) {

      $state.go("product-category", {
        type: 'category',
        value: category.id,
        name: category.name
      });
    }

    function sortObject(obj) {

      var arr = [];

      for (var prop in obj) {

        if (obj.hasOwnProperty(prop)) {
          arr.push(prop);
        }
      }

      arr = arr.sort();
      var tempObj = {};
      var length = 0;
      for (var prop in arr) {
        tempObj[arr[prop]] = obj[arr[prop]];
        length++;
      }

      $scope.category = {

        length: length
      }

      return tempObj;
    }

    $scope.gotoAnchor = function(x) {

      var newHash = 'anchor' + x;
      if ($location.hash() !== newHash) {
        // set the $location.hash to `newHash` and
        // $anchorScroll will automatically scroll to it
        $location.hash('anchor' + x);
      } else {
        // call $anchorScroll() explicitly,
        // since $location.hash hasn't changed
        $anchorScroll();
      }
    }

    $scope.removeDollarSign = function(name){
       var new_name = name.replace(/\$/g, ",");
       return new_name;
    }


  });